import capitalize from 'lodash/capitalize';

interface GetFullNameProps {
  title?: string | null;
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
}

export const getFullName = (customer: GetFullNameProps | undefined) => {
  if (!customer) return '';
  return [
    capitalize(customer.title ?? ''),
    customer.firstName ?? '',
    customer.lastName ?? '',
  ]
    .filter(Boolean)
    .join(' ');
};
